import React from 'react';
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PlusMinus = ({
  label,
  maxCount,
  minCount,
  currentCount,
  onCountChange,
  disabled,
  buttonsRole
}: {
  label: string;
  minCount?: number;
  maxCount?: number;
  currentCount: number;
  onCountChange: (count: number) => void;
  disabled?: boolean;
  buttonsRole?: React.AriaRole;
}): JSX.Element => {
  const handleCountChange = (isPlus: boolean): void => {
    if (isPlus && (maxCount === undefined || currentCount < maxCount)) {
      onCountChange(currentCount + 1);
    } else if (!isPlus && (minCount === undefined || currentCount > minCount)) {
      onCountChange(currentCount - 1);
    }
  };

  return (
    <div className={`plus-minus${disabled ? ' plus-minus--disabled' : ''}`}>
      <span className="plus-minus__label">{label}</span>
      <span className="plus-minus__buttons">
        <button
          role={buttonsRole}
          onClick={(): void => (!disabled ? handleCountChange(false) : undefined)}
        >
          <FontAwesomeIcon icon={faMinusCircle} />
        </button>
        <span>{currentCount}</span>
        <button
          role={buttonsRole}
          onClick={(): void => (!disabled ? handleCountChange(true) : undefined)}
        >
          <FontAwesomeIcon icon={faPlusCircle} />
        </button>
      </span>
    </div>
  );
};

export default PlusMinus;
